import { getAssetUrl } from "@/utils/common";

// 卡片尺寸和间距常量
export const CARD_WIDTH = 188;
export const CARD_HEIGHT = 132;
export const CARD_MARGIN = 10;


export const marginLeft = 400;
export const marginTop = 200;

export const screenWidth = 3120 - 600;
export const screenHeight = 1560 - 500;






export const LocalMaterialMap = new Map<string,string[]>([
  // 首届国际青春诗会金砖国家专场杭州开幕
  [
    '3bfeea6d-8c23-4be4-ad88-6ff10164a832',
    [
      getAssetUrl('images/event/material/3bfeea6d-8c23-4be4-ad88-6ff10164a832/1.jpeg'),
      getAssetUrl('images/event/material/3bfeea6d-8c23-4be4-ad88-6ff10164a832/2.jpeg'),
      getAssetUrl('images/event/material/3bfeea6d-8c23-4be4-ad88-6ff10164a832/3.jpeg'),
      getAssetUrl('images/event/material/3bfeea6d-8c23-4be4-ad88-6ff10164a832/4.jpeg'),
      getAssetUrl('images/event/material/3bfeea6d-8c23-4be4-ad88-6ff10164a832/5.jpeg'),
      getAssetUrl('images/event/material/3bfeea6d-8c23-4be4-ad88-6ff10164a832/6.jpeg'),
      getAssetUrl('images/event/material/3bfeea6d-8c23-4be4-ad88-6ff10164a832/7.jpeg'),
    ]
  ]
])